import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Page from "../../finwell/pages/Page";
import ReportDashboardSection from "../../components/Reports/ReportDashboardSection";
import {
  loginBrokerResponse,
  loginIframeUserResponse,
} from "../../redux/auth/actions";
import {
  userDetailIframeUser,
  setIframeUserRole,
  getBrandTheme,
} from "../../redux/user/actions";
import { applyTheme, clickStreamUser, SessionKeys } from "../../utils/AppUtils";
import CONFIG from "../../utils/config";
import $ from "jquery";
import _ from "lodash";

const ReportDashboardMobile = () => {
  const dispatch = useDispatch();

  const search = window.location.search;
  const params = new URLSearchParams(search);
  const token = params.get("token");
  const key = params.get("key");
  const username = params.get("username");
  const user_id = params.get("user_id");
  const color_1 = params.get("color_1");
  const color_2 = params.get("color_2");
  const role = params.get("role");
  const is_corporate = params.get("is_corporate");
  const office = params.get("office");
  const hide_save_filter = params.get("hide_save_filter");

  const apply_theme = params.get("apply_theme");

  const brandThemeRes = useSelector((state) => state.user.brandThemeRes);

  const [isLoading, setIsLoading] = useState(true);
  const [isValidKey, setIsValidKey] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);

    // let sendHeight = setInterval(() => {
    //     let obj = { 'method': 'height', 'value': document.body.scrollHeight }
    //     console.log('height: ', obj);
    //     window.parent.postMessage(obj, CONFIG.API_URL_BROKER_ADMIN);
    // }, 3000)

    // return (() => { clearInterval(sendHeight) })
    const timeout = setTimeout(() => {
      const obj = { method: "height", value: document.body.scrollHeight };
      console.log("height: ", obj);
      window.parent.postMessage(obj, "*");
    }, 3000);

    return () => clearTimeout(timeout);
  }, []);

  useEffect(() => {
    if (key === CONFIG.KEY.MOBILE_ACCESS_KEY) {
      $("html").css(
        "--color-element-1",
        color_1 ? "#" + color_1 : CONFIG.COLOR_ELEMENT_1
      );
      $("html").css(
        "--color-element-2",
        color_2 ? "#" + color_2 : CONFIG.COLOR_ELEMENT_2
      );
      localStorage.setItem(SessionKeys.API_TOKEN, token);
      localStorage.setItem(SessionKeys.IFRAME_USERNAME, username);
      setIsValidKey(true);
      dispatch(setIframeUserRole(role));
      dispatch(
        loginIframeUserResponse({
          payload: {
            user: {
              user_id: user_id,
              username: username,
              role: [role],
              is_corporate: _.toNumber(is_corporate) === 1 ? true : false,
              config: {
                office_name: office,
              },
            },
            apiToken: token,
          },
        })
      );

      dispatch(
        userDetailIframeUser({
          module: "getOrderDetailBroker",
          apiToken: token,
          userId: user_id,
        })
      );
      clickStreamUser("report_mobile_page", {
        userId: user_id,
      });

      if (apply_theme === "true") {
        dispatch(
          getBrandTheme({
            module: "getBrandTheme",
            postData: {
              token: token,
            },
          })
        );
      }

      // TODO: REMOVE
      // setIsValidKey(false)
    }
  }, [token, key, user_id, dispatch]);

  useEffect(() => {
    console.log("brandThemeRes: ", brandThemeRes);
    if (!_.isEmpty(brandThemeRes)) {
      if (brandThemeRes?.status === "success") {
        const branding = brandThemeRes.payload.payload.branding;
        !_.isEmpty(branding) && applyTheme(branding);
      }
    }
  }, [brandThemeRes]);

  useEffect(() => {
    if (document.getElementById("id_page_404") !== null) {
      document.getElementById("id_page_404").style.display = "none";
    }
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
    setTimeout(() => {
      if (document.getElementById("cc_div") !== null)
        document.getElementById("cc_div").style.display = "none";
    }, 100);
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);

    let sendHeight = setInterval(() => {
      let obj = { method: "height", value: 700 };
      console.log("height: ", obj);
      window.parent.postMessage(obj, "*");
    }, 3000);

    return () => {
      clearInterval(sendHeight);
    };
  }, []);

  return (
    <>
      {isValidKey ? (
        <>
          <div className="container pb-2rem">
            <ReportDashboardSection
              isMobile={true}
              hideSaveFilter={hide_save_filter}
            />
          </div>
        </>
      ) : (
        <div>Invalid Key</div>
      )}
    </>
  );
};

export default ReportDashboardMobile;
